import CoolenWordStudyData from "@/pcomponents/common/content/coolen/study/func/word_study_data";
import StudySortListArea from "./study_sort";
import TotalArea from "./total";

function StudySortArea(props: any) {
  let myProps = {
    Style: {},
    todo_info: null,
    word_pre_info: null,
    ...props
  };
  let Style = myProps.Style;
  let word_pre_info = myProps.word_pre_info;
  let study_sort_det_arr = CoolenWordStudyData.get_study_det_arr({ study_sort: "cg_word" });
  let study_sort_arr = CoolenWordStudyData.get_study_sort_arr({ study_sort: "cg_word" });

  let last_update_date_str = "";
  if (word_pre_info.group_stu_info.a_update_date) {
    last_update_date_str = word_pre_info.group_stu_info.a_update_date;
  }
  return (
    <div>
      <StudySortListArea
        Style={Style}
        study_sort_arr={study_sort_arr}
        study_sort_det_arr={study_sort_det_arr}
        word_pre_info={word_pre_info}
      ></StudySortListArea>
      <TotalArea
        Style={Style}
        word_pre_info={word_pre_info}
      ></TotalArea>

    </div>
  );
};
export default StudySortArea;